import { CustomerStatus } from './constants/customer-status.js';
const INACTIVE_CUSTOMER_STATUSES = new Set([
    CustomerStatus.OUT_OF_BUSINESS,
    CustomerStatus.DO_NOT_CALL,
]);
export function applyCustomerStatusIdChange(statusId) {
    if (INACTIVE_CUSTOMER_STATUSES.has(statusId)) {
        return { activeFlag: false, statusId };
    }
    return { statusId };
}
/** Relationship statuses editable in the form; setCustomerActive is a deliberately decoupled soft-delete toggle that never touches statusId. */
export function isEditableCustomerRelationshipStatus(statusId) {
    return !INACTIVE_CUSTOMER_STATUSES.has(statusId);
}
//# sourceMappingURL=customer-lifecycle.js.map